import React from 'react';
import { useSelector } from 'react-redux';

import useMartyContext from 'hooks/useMartyContext';
import Breadcrumbs from 'components/common/Breadcrumbs';
import { cn } from 'helpers/classnames';
import { selectAuthentication } from 'selectors/authentication';
import { returnToAccountPath } from 'constants/appConstants';

import css from 'styles/components/account/accountBreadcrumbs.scss';

const accountLinkName = 'Account Overview';

const AccountBreadcrumbs = ({ allowUnknownAuth = false, links = [], hideOnMobile = true, homeLinkName = accountLinkName, ...props }) => {
  const { testId } = useMartyContext();
  const authentication = useSelector(selectAuthentication);

  const isRendered = allowUnknownAuth ? authentication || authentication === null : authentication === true;

  if (!isRendered) {
    return null;
  }

  const accountOverviewBreadcrumb = {
    'to': returnToAccountPath,
    'data-test-id': testId('accountOverviewBreadcrumb'),
    'text': homeLinkName
  };
  const accountLinks = [accountOverviewBreadcrumb, ...links];
  return (
    <Breadcrumbs
      links={accountLinks}
      hideOnMobile={hideOnMobile}
      className={cn(css.accountBreadcrumbs, { [css.hideOnMobile]: hideOnMobile })}
      {...props}
    />
  );
};

export default AccountBreadcrumbs;
